var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[ 'applause-meter-wrapper', _vm.rating ]},[_c('div',{staticClass:"meter-fill"}),_vm._v(" "),_c('div',{staticClass:"meter-label"},[_vm._v("Applause")])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-68752783","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vue-svg-inline-loader/dist/index.min.js??ref--6!./src/components/game/sidebar/ApplauseMeter.vue
// module id = null
// module chunks = 